export interface VoiceFrame {
  type: "voice";
  case?: string;
  say?: unknown;
  know?: unknown;
  next?: unknown;
}

export interface VoicePlan {
  say: string[];
  know: string[];
  next: string | null;
  endsProgress: boolean;
  failed: boolean;
}

const PROGRESS_END_CASES = ["ready", "results", "failed"];

const texts = (value: unknown): string[] =>
  Array.isArray(value)
    ? value
        .filter((item): item is string => typeof item === "string")
        .map((item) => item.trim())
        .filter((item) => item.length > 0)
    : [];

export function planVoiceFrame(frame: Partial<VoiceFrame> | null | undefined): VoicePlan {
  const next = typeof frame?.next === "string" && frame.next.trim() ? frame.next.trim() : null;
  const endsProgress = typeof frame?.case === "string" && PROGRESS_END_CASES.includes(frame.case);
  return { say: texts(frame?.say), know: texts(frame?.know), next, endsProgress, failed: frame?.case === "failed" };
}

export function isUserSpeaking(now: number, lastUserAt: number | null, quietMs: number): boolean {
  return lastUserAt !== null && now - lastUserAt < quietMs;
}

export function shouldDropNext(lastUserAt: number | null, sinceAt: number): boolean {
  return lastUserAt !== null && lastUserAt > sinceAt;
}

export type DelegationOutcome = "sent" | "busy" | "empty";

export function decideDelegation(text: string, requestRunning: boolean): DelegationOutcome {
  if (requestRunning) return "busy";
  return text.trim() ? "sent" : "empty";
}
